<template>  
  <div class="container-filho planosVinculados">
    <p class="p--planosVinculados">Planos vinculados</p>    
    <template
      v-for="(item, index) in listaChaves" :key="index"
    >
      <ItemSelecao        
        :imagem="item.avatar"
        :textoprincipal="item.nome"
        :textosecundario="item.plano ? 'Plano ' + item.plano : ''"        
        @click.prevent="() => trocarParticipacao(item, index)"
      />
    </template>
  </div>
  <Modal v-if="modalenviarNascimento" style="padding: 0px">
    <template v-slot:body>
      <div class="container-filho display-modal">
        <div class="mf__div-flex-space-between">
          <Titulo :title="'Puxa vida!'" style="margin-top: 30px !important" />
          <span @click="modalenviarNascimento = false">X</span>
        </div>
        <p>
          Não identificamos a data de nascimento de <b>{{ beneficiario.nome }}</b>
        </p>
        <p>Por favor digite-a abaixo para prosseguir:</p>
        <input
          inputmode="numeric"
          v-maska="'##/##/####'"
          :masked="true"
          v-model="dataNascimento"
          style="width: 99% !important"
          placeholder="dd/mm/aaaa"
        />
        <small class="msg-error" v-if="erro" style="margin-left: 0">{{ erro }}</small>
        <button
          class="mf__mt-5"
          @click="reenviarDataNascimento(beneficiario)"
          :disabled="dataNascimento.length < 10"
        >
          Enviar
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Titulo from "../components/Titulo.vue";
import ItemSelecao from "./ItemSelecao.vue";
import Modal from "./Modal.vue";
import FirebaseHelper from "../service/FirebaseHelper";
import maleAdult from "../../public/imagens/icons/avatar-male-adult.png";
import femaleAdult from "../../public/imagens/icons/avatar-female-adult.png";
import maleKid from "../../public/imagens/icons/avatar-male-kid.png";
import femaleKid from "../../public/imagens/icons/avatar-female-kid.png";
import maleYoung from "../../public/imagens/icons/avatar-male-young.png";
import femaleYoung from "../../public/imagens/icons/avatar-female-young.png";
import avatarGenerico from "../../public/imagens/silhouette.jpg";
import { vMaska } from "maska/vue"

export default {
  directives:{ maska: vMaska },
  components: {
    Titulo,
    Modal,
    ItemSelecao,
  },
  props: {
    listaChaves: [],
    origem: null
  },
  computed: {
    ...mapGetters({
      chave: "chave",
      cpf: "cpf",
      uid: "uid",
      participante: "participante",
      isRP: "isRP"
    }),
  },
  data() {
    return {
      childCounter:0,
      firebaseHelper: new FirebaseHelper(),
      dataNascimento: "",
      beneficiario: null,
      erro: "",
      modalenviarNascimento: false,
      maleAdult: maleAdult,
      maleYoung: maleYoung,
      maleKid: maleKid,
      femaleAdult: femaleAdult,
      femaleYoung: femaleYoung,
      femaleKid: femaleKid,
      avatarGenerico: avatarGenerico,
    };
  },
  created() {   
    this.listaChaves.forEach((item) => {
      if (!item.avatar.includes("https://")) {
        if (item.avatar === "maleAdult") {
          item.avatar = maleAdult;
        } else if (item.avatar === "maleYoung") {
          item.avatar = maleYoung;
        } else if (item.avatar === "maleKid") {
          item.avatar = maleKid;
        } else if (item.avatar === "femaleAdult") {
          item.avatar = femaleAdult;
        } else if (item.avatar === "femaleYoung") {
          item.avatar = femaleYoung;
        } else if (item.avatar === "femaleKid") {
          item.avatar = femaleKid;
        } else {
          item.avatar = avatarGenerico;
        }
      }
    });
  },
  methods: {
    ...mapActions(["atualizarEstadoParticipante"]),
    increment(item) {
      // emit custom update event to update the parent value
    },
    trocarParticipacao(item) {
      console.log('item',item)
      if (item.chave || item.nascimento) {
        this.$emit('update:novoParticipante', item);
        //this.$emit("troca_participacao", item);
      } else if (!item.nascimento) {
        this.beneficiario = item;
        this.modalenviarNascimento = true;
      }
    },
    idade(nascimento, hoje) {
      var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
      if (
        new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
        new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())
      ) {
        diferencaAnos--;
      }
      return diferencaAnos;
    },
    async reenviarDataNascimento(beneficiario) {
      this.erro = "";
      if (!this.dataNascimento) {
        this.erro = "Por favor, insira a data de nascimento";
      } else {
        var olddate = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
        var datenow = new Date();
        var data = new Date(this.dataNascimento);
        var idade = this.idade(data, datenow);
        if (data <= olddate || data >= datenow) {
          this.erro = "Data de nascimento inválida!";
          return;
        } else {
          for (var k = 0; k < this.participante.data.cadastro.beneficiarios.length; k++) {
            if (
              this.participante.data.cadastro.beneficiarios[k].nome === beneficiario.nome
            ) {
              this.participante.data.cadastro.beneficiarios[
                k
              ].nascimento = this.dataNascimento;
              beneficiario.nascimento = this.dataNascimento;
              break;
            }
          }
          this.atualizarEstadoParticipante(this.participante);
          var response = "";
          if (!this.isRP) {
            response = await this.firebaseHelper.atualizarBenficiarios(
              this.chave,
              this.participante.data.cadastro.beneficiarios
            );
          } else {
            response = true;
          }
          if (response) {
            if (idade < 18) {
              this.modalenviarNascimento = false;
              this.homeBeneficiarioSemAdesaoMenor = true;
              this.dataNascimento = "";
              this.$router.push({
                path: "/adesaomenoridade",
                query: { beneficiario: beneficiario },
              });
            } else {
              this.$router.push({
                path: "/adesaomaioridade",
                query: { beneficiario: beneficiario },
              });
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.planosVinculados {
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  top: 100px;
  left: 0px;
  background-color: white;
}

/* Slider: Imagem */
.box-image--acessoRapido {
  border-radius: 8px;
  height: 60px;
  width: 60px;
  margin-left: 5px;
  margin-right: 5px;
  opacity: 1;
  background-color: #4b99ff;
  border-radius: 50px;
}

.slide__img--acessoRapido {
  height: 70px;
  padding: 10px;
  margin-left: 4px;
  transition: 0.5s ease;
  backface-visibility: hidden;
  object-fit: cover;
}

.box-image--acessoRapido:hover .slide__img--acessoRapido {
  opacity: 0.3;
}

.p--slide {
  font-size: 10px;
  line-height: 15px;
  margin-top: 5px;
  text-align: center;
}

.p--planosVinculados {
  font-weight: bold;
  margin: 7px 0 0px 0;
  font-size: 12px;
  line-height: 17px;
}
</style>
